import { vettedKeys } from "constants/entities";
import {
	Box,
	Typography,
	List,
	ListItem,
	Divider,
	Tooltip,
	Stack,
} from "@mui/material";
import { lightBlue } from "@mui/material/colors";

const groupVettedFields = () => {
	const grouped = {};

	Object.entries(vettedKeys).forEach(([key, { label, group }]) => {
		if (!grouped[group]) grouped[group] = [];
		grouped[group].push({ key, label });
	});

	return grouped;
};

export const VettedProfileIcon = ({ color = "primary" }) => {
	return (<Box
		sx={{
			width: '12px',
			height: "12px",
			backgroundColor: color,
			clipPath: "polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)"
		}}
	></Box>)
}

const VettedProfileRequirements = ({ label }) => {

	const groupedFields = groupVettedFields();
	const vettedProfileColor = lightBlue[600];

	return (
		<Tooltip

			componentsProps={{
				tooltip: {
					sx: {
						backgroundColor: 'white',
						color: 'rgba(0, 0, 0, 0.87)',
						maxWidth: 700,
						border: "4px solid white",
						borderLeftColor: vettedProfileColor,
						boxShadow: 3,
						overflowY: 'scroll'
					},
				},
			}}
			title={
				<Stack>

					<Stack direction="row" alignItems="center" gap={1}>
						<VettedProfileIcon color={vettedProfileColor} />
						<Typography fontSize="0.875rem" fontWeight="bold">Vetted profile required fields</Typography>
					</Stack>

					<Stack>
						<Typography fontSize="0.75rem" gutterBottom>
							To complete a vetted profile, make sure these fields are filled:
						</Typography>

						{Object.entries(groupedFields).map(([groupName, fields],index,array) => (
							<Stack key={groupName}>
								<Typography fontSize="0.75rem" fontWeight="bold" color="text.secondary">
									{groupName}
								</Typography>
								<List dense sx={{ p: 0 }}>
									{fields.map(({ key, label }) => (
										<ListItem key={key} sx={{ p: 0, pl: 1, }}>
											<Typography component="li" fontSize="0.75rem" color="text.secondary">
												{`• ${label}`}
											</Typography>
										</ListItem>
									))}
								</List>
								{index < array.length - 1 && <Divider sx={{ my: 0.5 }} />}
							</Stack>
						))}
					</Stack>
				</Stack>
			}

		>
			<Stack direction="row" alignItems="center" gap={1}>
				<VettedProfileIcon color={vettedProfileColor} />
				{label && <Typography>{label}</Typography>}
			</Stack>
		</Tooltip>
	);
};

export default VettedProfileRequirements;